import { BehaviorSubject } from "rxjs";

const currentWinners$ = new BehaviorSubject([]);

export default currentWinners$;
